 export const getImage = (jobCardImage) => {
    // Handle both field name formats: with and without _url suffix
    // Also handle is_embroidary_image and is_degitizer_image flags or determine from which image exists
    if (jobCardImage.is_embroidary_image) {
      return jobCardImage.embroidary_image || jobCardImage.embroidary_image_url;
    }
    if (jobCardImage.is_degitizer_image) {
      return jobCardImage.degitizer_image || jobCardImage.degitizer_image_url;
    } else {
      return jobCardImage.designer_image || jobCardImage.designer_image_url;
    }
  }
  
  // Helper for jobcard-image-detail API which uses _url suffix and may not have is_degitizer_image
  export const getImageFromDetail = (jobCardImage) => {
    // Check embroidary image first
    if (jobCardImage.embroidary_image_url) {
      return jobCardImage.embroidary_image_url;
    }
    if (jobCardImage.embroidary_image) {
      return jobCardImage.embroidary_image;
    }
    // If degitizer_image_url exists and is not null, prefer it
    if (jobCardImage.degitizer_image_url) {
      return jobCardImage.degitizer_image_url;
    }
    // Otherwise use designer_image_url
    if (jobCardImage.designer_image_url) {
      return jobCardImage.designer_image_url;
    }
    // Fallback to non-_url fields if they exist
    if (jobCardImage.degitizer_image) {
      return jobCardImage.degitizer_image;
    }
    if (jobCardImage.designer_image) {
      return jobCardImage.designer_image;
    }
    return null;
  }
  
  // Helper to determine who uploaded the image (for jobcard-image-detail API)
  export const getImageUploader = (jobCardImage) => {
    // Check is_embroidary_image flag first
    if (jobCardImage.is_embroidary_image !== undefined) {
      if (jobCardImage.is_embroidary_image) return "Embroidary";
    }
    // Check if embroidary_image_url exists and is not null
    if (jobCardImage.embroidary_image_url) {
      return "Embroidary";
    }
    // Fallback to non-_url fields
    if (jobCardImage.embroidary_image) {
      return "Embroidary";
    }
    // Check if degitizer_image_url exists and is not null
    if (jobCardImage.degitizer_image_url) {
      return "Digitizer";
    }
    // Check if designer_image_url exists and is not null
    if (jobCardImage.designer_image_url) {
      return "Designer";
    }
    // Fallback to non-_url fields
    if (jobCardImage.degitizer_image) {
      return "Digitizer";
    }
    if (jobCardImage.designer_image) {
      return "Designer";
    }
    // Check is_degitizer_image flag if available
    if (jobCardImage.is_degitizer_image !== undefined) {
      return jobCardImage.is_degitizer_image ? "Digitizer" : "Designer";
    }
    return null;
  }
